module.exports = __webpack_public_path__ + "static/media/edit_profile-image3.b19f7bbd.jpg";